"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getLicenses = getLicenses;
exports.has = has;
exports.hasSome = hasSome;
exports.hasEvery = hasEvery;
exports.not = not;
exports.notSome = notSome;
exports.notEvery = notEvery;

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _environment = require("../environment");

var _utils = require("../utils");

var _internals = require("../utils/internals");

var cachedLicenses;

function getLicenses(_x) {
  return _getLicenses.apply(this, arguments);
}

function _getLicenses() {
  _getLicenses = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(force) {
    return _regenerator.default.wrap(function _callee3$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!cachedLicenses || force) {
              cachedLicenses = (0, _environment.getRoute)('ProvisioningServices').then(function (base) {
                return "".concat(base, "/v1/licenses");
              }).then( /*#__PURE__*/function () {
                var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(url) {
                  return _regenerator.default.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          return _context.abrupt("return", fetch(url, {
                            headers: (0, _utils.jsonHeaders)(),
                            method: 'GET'
                          }));

                        case 1:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x16) {
                  return _ref.apply(this, arguments);
                };
              }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
                var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(response) {
                  return _regenerator.default.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          return _context2.abrupt("return", response.json());

                        case 1:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function (_x17) {
                  return _ref2.apply(this, arguments);
                };
              }()).then(function (body) {
                var _context3;

                return (0, _map.default)(_context3 = body.featureResources).call(_context3, function (val) {
                  var _context4;

                  return (0, _concat.default)(_context4 = "".concat(val.feature, ".")).call(_context4, val.resource);
                });
              });
            }

            return _context5.abrupt("return", cachedLicenses);

          case 2:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee3);
  }));
  return _getLicenses.apply(this, arguments);
}

function has(_x2, _x3, _x4) {
  return _has.apply(this, arguments);
}

function _has() {
  _has = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(licenses, hasEveryProp, force) {
    return _regenerator.default.wrap(function _callee4$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", getLicenses(force).then(function (grants) {
              var granted = false;

              if ((0, _isArray.default)(licenses)) {
                licenses[hasEveryProp ? 'every' : 'some'](function (license) {
                  if (grants) {
                    granted = (0, _includes.default)(grants).call(grants, license);
                  } else {
                    granted = false;
                  }

                  return granted;
                });
              } else if (typeof licenses === 'string') {
                if (grants) {
                  granted = (0, _includes.default)(grants).call(grants, licenses);
                }
              }

              return Boolean(granted);
            }));

          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee4);
  }));
  return _has.apply(this, arguments);
}

function hasSome(_x5, _x6) {
  return _hasSome.apply(this, arguments);
}

function _hasSome() {
  _hasSome = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(licenses, force) {
    return _regenerator.default.wrap(function _callee5$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt("return", has(licenses, force));

          case 1:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee5);
  }));
  return _hasSome.apply(this, arguments);
}

function hasEvery(_x7, _x8) {
  return _hasEvery.apply(this, arguments);
}

function _hasEvery() {
  _hasEvery = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(licenses, force) {
    return _regenerator.default.wrap(function _callee6$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt("return", has(licenses, true, force));

          case 1:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee6);
  }));
  return _hasEvery.apply(this, arguments);
}

function not(_x9, _x10, _x11) {
  return _not.apply(this, arguments);
}

function _not() {
  _not = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(licenses, hasEveryProp, force) {
    return _regenerator.default.wrap(function _callee7$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            return _context9.abrupt("return", has(licenses, hasEveryProp, force).then(function (result) {
              return !result;
            }));

          case 1:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee7);
  }));
  return _not.apply(this, arguments);
}

function notSome(_x12, _x13) {
  return _notSome.apply(this, arguments);
}

function _notSome() {
  _notSome = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(licenses, force) {
    return _regenerator.default.wrap(function _callee8$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            return _context10.abrupt("return", not(licenses, false, force));

          case 1:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee8);
  }));
  return _notSome.apply(this, arguments);
}

function notEvery(_x14, _x15) {
  return _notEvery.apply(this, arguments);
}

function _notEvery() {
  _notEvery = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9(licenses, force) {
    return _regenerator.default.wrap(function _callee9$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            return _context11.abrupt("return", not(licenses, true, force));

          case 1:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee9);
  }));
  return _notEvery.apply(this, arguments);
}
